import { Sidebar, UserHomePage } from "src/utils/interfaces/interfaces";

export const SUPER_ADMIN_USER_TYPE = "superAdmin";
export const ADMIN_USER_TYPE = "admin";
export const SHIPPER_USER_TYPE = "shipper";
export const ENFORCEMENT_USER_TYPE = "enforcement";

export const ALLOWED_USER_TYPES = [
  SUPER_ADMIN_USER_TYPE,
  ADMIN_USER_TYPE,
  SHIPPER_USER_TYPE,
  ENFORCEMENT_USER_TYPE,
];

export enum USER_TYPES {
  SUPER_ADMIN = "superAdmin",
  ADMIN = "admin",
  SHIPPER = "shipper",
  ENFORCEMENT = "enforcement",
}

export const SIDEBAR_ITEMS: Sidebar = {
  [SUPER_ADMIN_USER_TYPE]: [
    // {
    //   id: "dashboard",
    //   route: "/dashboard",
    //   name: "Dashboard",
    //   src: "/assets/icons/sidebar/dashboard.svg",
    // },
    {
      id: "orders",
      route: "/orders",
      name: "Orders",
      src: "/assets/icons/sidebar/inventory.svg",
      activeSrc: "/assets/icons/sidebar/inventory_focus.svg",
    },
    {
      id: "inventory",
      route: "/inventory",
      name: "Inventory",
      src: "/assets/icons/sidebar/inventory.svg",
    },
    {
      id: "members",
      route: "/members",
      name: "Members",
      src: "/assets/icons/sidebar/members.svg",
      activeSrc: "/assets/icons/sidebar/members_active.svg",
    },
  ],
  [ADMIN_USER_TYPE]: [
    // {
    //   id: "dashboard",
    //   route: "/dashboard",
    //   name: "Dashboard",
    //   src: "/assets/icons/sidebar/dashboard.svg",
    // },
    {
      id: "orders",
      route: "/orders",
      name: "Orders",
      src: "/assets/icons/sidebar/inventory.svg",
      activeSrc: "/assets/icons/sidebar/inventory_focus.svg",
    },
    {
      id: "inventory",
      route: "/inventory",
      name: "Inventory",
      src: "/assets/icons/sidebar/inventory.svg",
    },
    {
      id: "members",
      route: "/members",
      name: "Members",
      src: "/assets/icons/sidebar/members.svg",
      activeSrc: "/assets/icons/sidebar/members_active.svg",
    },
  ],
  [SHIPPER_USER_TYPE]: [
    {
      id: "orders",
      route: "/orders",
      name: "Orders",
      src: "/assets/icons/sidebar/inventory.svg",
      activeSrc: "/assets/icons/sidebar/inventory_focus.svg",
    },
    {
      id: "employees",
      route: "/employees",
      name: "Employees",
      src: "/assets/icons/sidebar/members.svg",
      activeSrc: "/assets/icons/sidebar/members_active.svg",
    },
    {
      id: "vehicles",
      route: "/vehicles",
      name: "Vehicles",
      src: "/assets/icons/sidebar/inventory.svg",
      activeSrc: "/assets/icons/orders/jobDetails/transport.svg",
    },
  ],
  [ENFORCEMENT_USER_TYPE]: [
    {
      id: "orders",
      route: "/orders",
      name: "Orders",
      src: "/assets/icons/sidebar/inventory.svg",
      activeSrc: "/assets/icons/sidebar/inventory_focus.svg",
    },
    {
      id: "inventory",
      route: "/inventory",
      name: "Inventory",
      src: "/assets/icons/sidebar/lock.svg",
      activeSrc: "/assets/icons/orders/events/unlock.svg",
    },
    {
      id: "profile",
      route: "/profile",
      name: "Profile",
      src: "/assets/icons/sidebar/shipper/profile.svg",
      activeSrc: "/assets/icons/sidebar/shipper/profile_active.svg",
      showInTabs: false,
    },
  ],
};

export const USER_HOME_PAGES: UserHomePage = {
  [SUPER_ADMIN_USER_TYPE]: {
    route: "/orders",
  },
  [ADMIN_USER_TYPE]: {
    route: "/orders",
  },
  [SHIPPER_USER_TYPE]: {
    route: "/orders",
  },
  [ENFORCEMENT_USER_TYPE]: {
    route: "/orders",
  },
};

export const Designations = [
  { code: "ceo", name: "Chief Executive Officer" },
  { code: "director", name: "Director" },
  { code: "gm", name: "General Manager" },
  { code: "cto", name: "Chief Technology Officer" },
  { code: "sales/marketng", name: "Sales/Marketing" },
  { code: "supervisor", name: "Supervisor" },
  { code: "others", name: "Others" },
];
